import {IPlansService} from './IPlansService';
import {PlansRepository} from './PlansRepository';
// import {Plan, PlanInsert} from '../../graphql/API';

// NEW CODE - Using @PikaDoApp/npm-pikado-logic
import {
  NewCreatePlanInput,
  NewUpdatePlanInput,
  AddExerciseToDayInput,
  RemoveExerciseFromDayInput,
  ReplaceExerciseInDayInput,
} from '@PikaDoApp/npm-pikado-logic/dist/modules/plan/graphql/plan.interface';
import {getCurrentAuthUserId} from '../../utils';

export class PlansService implements IPlansService {
  plansRepository: PlansRepository;
  constructor() {
    this.plansRepository = new PlansRepository();
  }

  // ========================================
  // OLD CODE - Commented out (kept for reference)
  // ========================================
  // async createPlan(plan: PlanInsert): Promise<Plan> {
  //   let createdPlan = await this.plansRepository.createPlan(plan);
  //   return createdPlan;
  // }
  //
  // async getPlanById(planId: string): Promise<Plan> {
  //   let plan = await this.plansRepository.getPlanById(planId);
  //   return plan;
  // }
  //
  // async updatePlan(
  //   planId: string,
  //   updatedAt: string,
  //   plan: string,
  // ): Promise<any> {
  //   return await this.plansRepository.updatePlan(planId, updatedAt, plan);
  // }
  //
  // async getDayPlan(planId: string, day: number): Promise<Plan> {
  //   let plan = await this.plansRepository.getDayPlan(planId, day);
  //   return plan;
  // }

  // ========================================
  // NEW CODE - Using @PikaDoApp/npm-pikado-logic
  // ========================================

  // Core CRUD Operations
  async newCreatePlan(
    name: string,
    duration: number,
    levelId: string | undefined,
    gradeId: string | undefined,
    curriculumId: string,
    placementTest?: string[],
    dailyExercises?: string[][],
  ): Promise<any> {
    try {
      const userId = getCurrentAuthUserId();

      console.log('🔍 [PLAN-SERVICE] Creating new plan:', {
        name,
        duration,
        levelId,
        gradeId,
        curriculumId,
        userId,
      });

      const planToCreate: NewCreatePlanInput = {
        name,
        duration,
        level: levelId,
        grade: gradeId,
        curriculum: curriculumId,
        createdBy: userId,
        placementTest,
        dailyExercises,
      };

      const createdPlan =
        await this.plansRepository.newCreatePlan(planToCreate);
      console.log('✅ [PLAN-SERVICE] Plan created successfully:', createdPlan);
      return createdPlan;
    } catch (error) {
      console.error('❌ [PLAN-SERVICE] Error creating plan:', error);
      throw error;
    }
  }

  async newUpdatePlan(
    id: string,
    name?: string,
    duration?: number,
    levelId?: string,
    gradeId?: string,
    curriculumId?: string,
    placementTest?: string[],
  ): Promise<any> {
    try {
      const userId = getCurrentAuthUserId();

      console.log('🔍 [PLAN-SERVICE] Updating plan:', {
        id,
        name,
        duration,
        levelId,
        gradeId,
        curriculumId,
        userId,
      });

      const planToUpdate: NewUpdatePlanInput = {
        id,
        name,
        duration,
        level: levelId,
        grade: gradeId,
        curriculum: curriculumId,
        placementTest,
        createdBy: userId,
      };

      const updatedPlan =
        await this.plansRepository.newUpdatePlan(planToUpdate);
      console.log('✅ [PLAN-SERVICE] Plan updated successfully:', updatedPlan);
      return updatedPlan;
    } catch (error) {
      console.error('❌ [PLAN-SERVICE] Error updating plan:', error);
      throw error;
    }
  }

  async getNewPlanById(id: string): Promise<any> {
    try {
      console.log('🔍 [PLAN-SERVICE] Fetching plan by id:', id);
      const plan = await this.plansRepository.getNewPlanById(id);
      console.log('✅ [PLAN-SERVICE] Plan fetched successfully:', plan);
      return plan;
    } catch (error) {
      console.error('❌ [PLAN-SERVICE] Error fetching plan:', error);
      throw error;
    }
  }

  async findAllPlans(): Promise<any[]> {
    try {
      console.log('🔍 [PLAN-SERVICE] Fetching all plans');
      const plans = await this.plansRepository.findAllPlans();
      console.log(
        '✅ [PLAN-SERVICE] Plans fetched successfully. Count:',
        plans.length,
      );
      return plans;
    } catch (error) {
      console.error('❌ [PLAN-SERVICE] Error fetching all plans:', error);
      throw error;
    }
  }

  async deletePlan(id: string): Promise<boolean> {
    try {
      console.log('🔍 [PLAN-SERVICE] Deleting plan with id:', id);
      const result = await this.plansRepository.deletePlan(id);
      console.log('✅ [PLAN-SERVICE] Plan deleted successfully:', result);
      return result;
    } catch (error) {
      console.error('❌ [PLAN-SERVICE] Error deleting plan:', error);
      throw error;
    }
  }

  // Query Operations
  async getPlanByLevelAndCurriculum(
    levelId: string,
    curriculumId: string,
  ): Promise<any> {
    try {
      console.log('🔍 [PLAN-SERVICE] Fetching plan by level and curriculum:', {
        levelId,
        curriculumId,
      });
      const plan = await this.plansRepository.getPlanByLevelAndCurriculum(
        levelId,
        curriculumId,
      );
      console.log('✅ [PLAN-SERVICE] Plan fetched successfully:', plan);
      return plan;
    } catch (error) {
      console.error(
        '❌ [PLAN-SERVICE] Error fetching plan by level and curriculum:',
        error,
      );
      throw error;
    }
  }

  async getPlansByCurriculum(curriculumId: string): Promise<any[]> {
    try {
      console.log(
        '🔍 [PLAN-SERVICE] Fetching plans by curriculum:',
        curriculumId,
      );
      const plans =
        await this.plansRepository.getPlansByCurriculum(curriculumId);
      console.log(
        '✅ [PLAN-SERVICE] Plans fetched successfully. Count:',
        plans.length,
      );
      return plans;
    } catch (error) {
      console.error(
        '❌ [PLAN-SERVICE] Error fetching plans by curriculum:',
        error,
      );
      throw error;
    }
  }

  async getPlanByGradeAndCurriculum(
    gradeId: string,
    curriculumId: string,
  ): Promise<any> {
    try {
      console.log('🔍 [PLAN-SERVICE] Fetching plan by grade and curriculum:', {
        gradeId,
        curriculumId,
      });
      const plan = await this.plansRepository.getPlanByGradeAndCurriculum(
        gradeId,
        curriculumId,
      );
      console.log('✅ [PLAN-SERVICE] Plan fetched successfully:', plan);
      return plan;
    } catch (error) {
      console.error(
        '❌ [PLAN-SERVICE] Error fetching plan by grade and curriculum:',
        error,
      );
      throw error;
    }
  }

  // Daily Exercise Management
  async addExerciseToDay(
    planId: string,
    dayIndex: number,
    exerciseId: string,
  ): Promise<any> {
    try {
      console.log('🔍 [PLAN-SERVICE] Adding exercise to day:', {
        planId,
        dayIndex,
        exerciseId,
      });

      const input: AddExerciseToDayInput = {
        planId,
        dayIndex,
        exerciseId,
      };

      const updatedPlan = await this.plansRepository.addExerciseToDay(input);
      console.log(
        '✅ [PLAN-SERVICE] Exercise added successfully:',
        updatedPlan,
      );
      return updatedPlan;
    } catch (error) {
      console.error('❌ [PLAN-SERVICE] Error adding exercise to day:', error);
      throw error;
    }
  }

  async removeExerciseFromDay(
    planId: string,
    dayIndex: number,
    exerciseId: string,
  ): Promise<any> {
    try {
      console.log('🔍 [PLAN-SERVICE] Removing exercise from day:', {
        planId,
        dayIndex,
        exerciseId,
      });

      const input: RemoveExerciseFromDayInput = {
        planId,
        dayIndex,
        exerciseId,
      };

      const updatedPlan =
        await this.plansRepository.removeExerciseFromDay(input);
      console.log(
        '✅ [PLAN-SERVICE] Exercise removed successfully:',
        updatedPlan,
      );
      return updatedPlan;
    } catch (error) {
      console.error(
        '❌ [PLAN-SERVICE] Error removing exercise from day:',
        error,
      );
      throw error;
    }
  }

  async replaceExerciseInDay(
    planId: string,
    dayIndex: number,
    oldExerciseId: string,
    newExerciseId: string,
  ): Promise<any> {
    try {
      console.log('🔍 [PLAN-SERVICE] Replacing exercise in day:', {
        planId,
        dayIndex,
        oldExerciseId,
        newExerciseId,
      });

      const input: ReplaceExerciseInDayInput = {
        planId,
        dayIndex,
        oldExerciseId,
        newExerciseId,
      };

      const updatedPlan =
        await this.plansRepository.replaceExerciseInDay(input);
      console.log(
        '✅ [PLAN-SERVICE] Exercise replaced successfully:',
        updatedPlan,
      );
      return updatedPlan;
    } catch (error) {
      console.error(
        '❌ [PLAN-SERVICE] Error replacing exercise in day:',
        error,
      );
      throw error;
    }
  }

  async getDailyExercisesByPlanAndDay(
    planId: string,
    dayNumber: number,
  ): Promise<any[]> {
    try {
      console.log('🔍 [PLAN-SERVICE] Fetching daily exercises for day:', {
        planId,
        dayNumber,
      });

      const exercises =
        await this.plansRepository.getDailyExercisesByPlanAndDay(
          planId,
          dayNumber,
        );
      console.log(
        '✅ [PLAN-SERVICE] Daily exercises fetched successfully. Count:',
        exercises.length,
      );
      return exercises;
    } catch (error) {
      console.error('❌ [PLAN-SERVICE] Error fetching daily exercises:', error);
      throw error;
    }
  }
}
